"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.number.constructor");
var _booking_return = require("@/api/goods_activity/booking_return");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RefundDetailTab',
  props: {
    orderId: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      refundData: {},
      loading: false,
      auditing: false,
      confirming: false,
      backingOff: false,
      auditForm: {
        returnMoney: 0,
        action: 'approve',
        reasonRefusal: ''
      },
      financeForm: {
        returnNote: ''
      }
    };
  },
  created: function created() {
    // 获取传递的退款单ID
    this.fetchRefundDetail();
  },
  watch: {
    // 监听退款数据变化，初始化表单
    refundData: {
      handler: function handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          // 初始化表单数据
          this.auditForm.returnMoney = newVal.returnMoney || newVal.orderAmount || 0;
        }
      },
      deep: true,
      immediate: true
    },
    // 监听退款单ID变化，重新获取数据
    orderId: {
      handler: function handler(newVal) {
        if (newVal) {
          this.fetchRefundDetail();
        }
      },
      immediate: true
    }
  },
  computed: {
    canOperate: function canOperate() {
      // 只有未受理(0)和已审核(4)状态可以操作
      return this.refundData.returnStatus === 0 || this.refundData.returnStatus === 4;
    }
  },
  methods: {
    fetchRefundDetail: function () {
      var _fetchRefundDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.orderId) {
                _context.next = 1;
                break;
              }
              this.$message.error('退款单ID不能为空');
              return _context.abrupt("return");
            case 1:
              this.loading = true;
              _context.prev = 2;
              _context.next = 3;
              return (0, _booking_return.getReturnInfo)(this.orderId);
            case 3:
              response = _context.sent;
              if (response.code === 200) {
                this.refundData = response.data || {};
              } else {
                this.$message.error(response.msg || '获取退款单详情失败');
              }
              _context.next = 5;
              break;
            case 4:
              _context.prev = 4;
              _t = _context["catch"](2);
              console.error('获取退款单详情失败:', _t);
              this.$message.error('获取退款单详情失败');
            case 5:
              _context.prev = 5;
              this.loading = false;
              return _context.finish(5);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function fetchRefundDetail() {
        return _fetchRefundDetail.apply(this, arguments);
      }
      return fetchRefundDetail;
    }(),
    getReturnStatusText: function getReturnStatusText(status) {
      var statusMap = {
        0: '未受理',
        1: '受理中',
        2: '受理完成',
        3: '商家已收货',
        4: '同意申请退款',
        5: '拒绝申请退款',
        6: '已退款',
        9: '已完成'
      };
      return statusMap[status] || '未知状态';
    },
    getReturnTypeText: function getReturnTypeText(type) {
      var typeMap = {
        1: '全额退款',
        2: '部分退款'
      };
      return typeMap[type] || '未知类型';
    },
    getPayTypeText: function getPayTypeText(type) {
      var typeMap = {
        1: '微信',
        2: '支付宝'
      };
      return typeMap[type] || '未知类型';
    },
    formatDate: function formatDate(value) {
      if (!value) return '';
      // 如果是时间戳格式
      if (typeof value === 'number') {
        var date = new Date(value);
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        var hours = String(date.getHours()).padStart(2, '0');
        var minutes = String(date.getMinutes()).padStart(2, '0');
        var seconds = String(date.getSeconds()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
      }
      // 如果是字符串格式
      if (typeof value === 'string') {
        var _date = new Date(value);
        if (isNaN(_date.getTime())) return value; // 无效日期返回原值
        var _year = _date.getFullYear();
        var _month = String(_date.getMonth() + 1).padStart(2, '0');
        var _day = String(_date.getDate()).padStart(2, '0');
        var _hours = String(_date.getHours()).padStart(2, '0');
        var _minutes = String(_date.getMinutes()).padStart(2, '0');
        var _seconds = String(_date.getSeconds()).padStart(2, '0');
        return "".concat(_year, "-").concat(_month, "-").concat(_day, " ").concat(_hours, ":").concat(_minutes, ":").concat(_seconds);
      }
      return value;
    },
    formatGoodsList: function formatGoodsList(goodsList) {
      if (!goodsList || !Array.isArray(goodsList) || goodsList.length === 0) {
        return '暂无商品信息';
      }
      return goodsList.map(function (item) {
        return "".concat(item.goods_name || item.goodsName || '', " \uFFE5").concat(item.goods_price || item.goodsPrice || '0.00', " x").concat(item.num || 1);
      }).join('；');
    },
    // 审核退款
    handleAudit: function () {
      var _handleAudit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this = this;
        var confirmMsg;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.auditForm.action) {
                _context3.next = 1;
                break;
              }
              this.$message.warning('请选择操作（同意或拒绝）');
              return _context3.abrupt("return");
            case 1:
              if (!(this.auditForm.action === 'reject' && !this.auditForm.reasonRefusal)) {
                _context3.next = 2;
                break;
              }
              this.$message.warning('请输入拒绝原因');
              return _context3.abrupt("return");
            case 2:
              confirmMsg = this.auditForm.action === 'reject' ? '确认拒绝退款申请？' : '确认通过退款申请？';
              this.$confirm(confirmMsg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params, response, _t2;
                return regeneratorRuntime.wrap(function (_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _this.auditing = true;
                      _context2.prev = 1;
                      params = {
                        returnId: _this.orderId,
                        returnMoney: _this.auditForm.returnMoney,
                        returnStatus: _this.auditForm.action === 'reject' ? 5 : 4,
                        // 5=拒绝, 4=同意
                        reasonRefusal: _this.auditForm.reasonRefusal || ''
                      };
                      _context2.next = 2;
                      return (0, _booking_return.auditBookingReturn)(params);
                    case 2:
                      response = _context2.sent;
                      if (response.code === 200) {
                        _this.$message.success('审核成功');
                        _this.fetchRefundDetail();
                        _this.$emit('refresh'); // 通知父组件刷新列表
                      } else {
                        _this.$message.error(response.msg || '审核失败');
                      }
                      _context2.next = 4;
                      break;
                    case 3:
                      _context2.prev = 3;
                      _t2 = _context2["catch"](1);
                      _this.$message.error(_t2.message || '审核失败');
                    case 4:
                      _context2.prev = 4;
                      _this.auditing = false;
                      return _context2.finish(4);
                    case 5:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, null, [[1, 3, 4, 5]]);
              }))).catch(function () {
                // 用户取消
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleAudit() {
        return _handleAudit.apply(this, arguments);
      }
      return handleAudit;
    }(),
    // 重置审核表单
    resetAuditForm: function resetAuditForm() {
      this.auditForm = {
        returnMoney: this.refundData.returnMoney || this.refundData.orderAmount || 0,
        action: 'approve',
        reasonRefusal: ''
      };
    },
    // 确认退款
    handleConfirmRefund: function () {
      var _handleConfirmRefund = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this.financeForm.returnNote) {
                _context5.next = 1;
                break;
              }
              this.$message.warning('请输入退款备注');
              return _context5.abrupt("return");
            case 1:
              this.$confirm('确认执行退款操作？此操作将调用天财POS接口进行实际退款', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var params, response, _t3;
                return regeneratorRuntime.wrap(function (_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _this2.confirming = true;
                      _context4.prev = 1;
                      params = {
                        returnId: _this2.orderId,
                        returnNote: _this2.financeForm.returnNote
                      };
                      _context4.next = 2;
                      return (0, _booking_return.confirmBookingReturn)(params);
                    case 2:
                      response = _context4.sent;
                      if (response.code === 200) {
                        _this2.$message.success('退款成功');
                        _this2.fetchRefundDetail();
                        _this2.$emit('refresh'); // 通知父组件刷新列表
                      } else {
                        _this2.$message.error(response.msg || '退款失败');
                      }
                      _context4.next = 4;
                      break;
                    case 3:
                      _context4.prev = 3;
                      _t3 = _context4["catch"](1);
                      _this2.$message.error(_t3.message || '退款失败');
                    case 4:
                      _context4.prev = 4;
                      _this2.confirming = false;
                      return _context4.finish(4);
                    case 5:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4, null, [[1, 3, 4, 5]]);
              }))).catch(function () {
                // 用户取消
              });
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleConfirmRefund() {
        return _handleConfirmRefund.apply(this, arguments);
      }
      return handleConfirmRefund;
    }(),
    // 回退状态
    handleBackOff: function () {
      var _handleBackOff = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _this3 = this;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.$confirm('确认回退退款状态到未受理？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var params, response, _t4;
                return regeneratorRuntime.wrap(function (_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _this3.backingOff = true;
                      _context6.prev = 1;
                      params = {
                        returnId: _this3.orderId
                      };
                      _context6.next = 2;
                      return (0, _booking_return.backOffBookingReturn)(params);
                    case 2:
                      response = _context6.sent;
                      if (response.code === 200) {
                        _this3.$message.success('回退成功');
                        _this3.fetchRefundDetail();
                        _this3.$emit('refresh'); // 通知父组件刷新列表
                      } else {
                        _this3.$message.error(response.msg || '回退失败');
                      }
                      _context6.next = 4;
                      break;
                    case 3:
                      _context6.prev = 3;
                      _t4 = _context6["catch"](1);
                      _this3.$message.error(_t4.message || '回退失败');
                    case 4:
                      _context6.prev = 4;
                      _this3.backingOff = false;
                      return _context6.finish(4);
                    case 5:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6, null, [[1, 3, 4, 5]]);
              }))).catch(function () {
                // 用户取消
              });
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function handleBackOff() {
        return _handleBackOff.apply(this, arguments);
      }
      return handleBackOff;
    }(),
    // 获取退款最终消息
    getRefundFinalMessage: function getRefundFinalMessage() {
      if (this.refundData.returnStatus === 5) {
        return "\u9000\u6B3E\u5DF2\u88AB\u62D2\u7EDD\u3002\u62D2\u7EDD\u539F\u56E0\uFF1A".concat(this.refundData.reasonRefusal || '无');
      } else if (this.refundData.returnStatus === 6) {
        return '退款已完成';
      } else if (this.refundData.returnStatus === 9) {
        return '退款已关闭';
      }
      return '';
    }
  }
};